import { instagramMock, listingModelesMock, texteSeoMock, titreFiltresModelesMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreFiltresModelesMock(true), listingModelesMock, instagramMock, texteSeoMock('gray')];

export const listingCuisineMock: SlugPage = {
  ...pageBase({
    title: 'Listing Cuisine',
    type: 'listing-cuisines',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
